import {defineMessages} from 'react-intl'

export const techSpecMessages = defineMessages({
    '3D_multi_air_facet': {
        defaultMessage: '3D Multi air facet',
        id: 'tech_spec_3D_multi_air_facet',
    },
    accessories_and_care: {defaultMessage: 'Accessories', id: 'tech_spec_accessories_and_care'},
    accessories_extended: {
        defaultMessage: 'Accessories extended',
        id: 'tech_spec_accessories_extended',
    },
    accessories_facet: {defaultMessage: 'Accessories facet', id: 'tech_spec_accessories_facet'},
    accessories_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_accessories_generalspecifications',
    },
    accessories_grill: {defaultMessage: 'Accessories', id: 'tech_spec_accessories_grill'},
    accessories_snackmaker: {defaultMessage: 'Accessories', id: 'tech_spec_accessories_snackmaker'},
    air_purifier_facet: {defaultMessage: 'Air purifier facet', id: 'tech_spec_air_purifier_facet'},
    air_purifier_heater_and_cooling_fan_air_purification: {
        defaultMessage: 'Air Purification',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_air_purification',
    },
    air_purifier_heater_and_cooling_fan_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_colourmaterialfinish',
    },
    air_purifier_heater_and_cooling_fan_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_controlpanel',
    },
    air_purifier_heater_and_cooling_fan_cooling_fan: {
        defaultMessage: 'Cooling Fan',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_cooling_fan',
    },
    air_purifier_heater_and_cooling_fan_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_features',
    },
    air_purifier_heater_and_cooling_fan_heating: {
        defaultMessage: 'Heating',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_heating',
    },
    air_purifier_heater_and_cooling_fan_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_miscellaneous',
    },
    air_purifier_heater_and_cooling_fan_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_air_purifier_heater_and_cooling_fan_technicaldata',
    },
    air_purifiers_categorygeneral: {
        defaultMessage: 'General',
        id: 'tech_spec_air_purifiers_categorygeneral',
    },
    air_purifiers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_air_purifiers_colourmaterialfinish',
    },
    air_purifiers_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_air_purifiers_controlpanel',
    },
    air_purifiers_features: {defaultMessage: 'Features', id: 'tech_spec_air_purifiers_features'},
    air_purifiers_filters: {defaultMessage: 'Filters', id: 'tech_spec_air_purifiers_filters'},
    air_purifiers_functions: {defaultMessage: 'Functions', id: 'tech_spec_air_purifiers_functions'},
    air_purifiers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_air_purifiers_miscellaneous',
    },
    air_purifiers_technical_data: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_air_purifiers_technical_data',
    },
    air_purifiers_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_air_purifiers_technicaldata',
    },
    aircon_extended: {defaultMessage: 'Aircon extended', id: 'tech_spec_aircon_extended'},
    attachments_br_airfryers: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_attachments_br_airfryers',
    },
    attachments_facet: {defaultMessage: 'Attachments facet', id: 'tech_spec_attachments_facet'},
    automatic_coffee_maker_facet: {
        defaultMessage: 'Automatic coffee maker facet',
        id: 'tech_spec_automatic_coffee_maker_facet',
    },
    barbecue_grills_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_barbecue_grills_accessories',
    },
    barbecue_grills_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_barbecue_grills_colourmaterialfinish',
    },
    barbecue_grills_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_barbecue_grills_controlpanel',
    },
    barbecue_grills_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_barbecue_grills_features',
    },
    barbecue_grills_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_barbecue_grills_functions',
    },
    barbecue_grills_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_barbecue_grills_technicaldata',
    },
    bean_to_cup_coffee_machines_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_bean_to_cup_coffee_machines_colourmaterialfinish',
    },
    bean_to_cup_coffee_machines_connectivity: {
        defaultMessage: 'Connectivity',
        id: 'tech_spec_bean_to_cup_coffee_machines_connectivity',
    },
    bean_to_cup_coffee_machines_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_bean_to_cup_coffee_machines_controlpanel',
    },
    bean_to_cup_coffee_machines_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_bean_to_cup_coffee_machines_features',
    },
    bean_to_cup_coffee_machines_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_bean_to_cup_coffee_machines_functions',
    },
    bean_to_cup_coffee_machines_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_bean_to_cup_coffee_machines_miscellaneous',
    },
    bean_to_cup_coffee_machines_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_bean_to_cup_coffee_machines_technicaldata',
    },
    blenders_and_spindle_drink_makers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_blenders_and_spindle_drink_makers_attachments',
    },
    blenders_and_spindle_drink_makers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_blenders_and_spindle_drink_makers_capacity',
    },
    blenders_and_spindle_drink_makers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_blenders_and_spindle_drink_makers_functions',
    },
    blenders_and_spindle_drink_makers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_blenders_and_spindle_drink_makers_generalspecifications',
    },
    blenders_and_spindle_drink_makers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_blenders_and_spindle_drink_makers_miscellaneous',
    },
    blenders_design: {defaultMessage: 'Design', id: 'tech_spec_blenders_design'},
    blenders_extended: {defaultMessage: 'Blenders extended', id: 'tech_spec_blenders_extended'},
    blenders_facet: {defaultMessage: 'Blenders facet', id: 'tech_spec_blenders_facet'},
    blenders_features: {defaultMessage: 'Features', id: 'tech_spec_blenders_features'},
    blenders_helpmechoose: {
        defaultMessage: 'Help me choose',
        id: 'tech_spec_blenders_helpmechoose',
    },
    blenders_packagecontents: {
        defaultMessage: 'Package Contents',
        id: 'tech_spec_blenders_packagecontents',
    },
    blenders_technicalfeatures: {
        defaultMessage: 'Technical Features',
        id: 'tech_spec_blenders_technicalfeatures',
    },
    br_corporate_benefit_facet: {
        defaultMessage: 'Braun Corporate benefit facet',
        id: 'tech_spec_br_corporate_benefit_facet',
    },
    breadmakers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_breadmakers_attachments',
    },
    breadmakers_capacity: {defaultMessage: 'Capacity', id: 'tech_spec_breadmakers_capacity'},
    breadmakers_functions: {defaultMessage: 'Functions', id: 'tech_spec_breadmakers_functions'},
    breadmakers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_breadmakers_generalspecifications',
    },
    breadmakers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_breadmakers_miscellaneous',
    },
    can_openers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_can_openers_generalspecifications',
    },
    can_openers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_can_openers_miscellaneous',
    },
    choppers_facet: {defaultMessage: 'Choppers facet', id: 'tech_spec_choppers_facet'},
    citrus_juicers_capacity: {defaultMessage: 'Capacity', id: 'tech_spec_citrus_juicers_capacity'},
    citrus_juicers_facets: {
        defaultMessage: 'Citrus juicers facets',
        id: 'tech_spec_citrus_juicers_facets',
    },
    citrus_juicers_features: {defaultMessage: 'Features', id: 'tech_spec_citrus_juicers_features'},
    citrus_juicers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_citrus_juicers_functions',
    },
    citrus_juicers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_citrus_juicers_generalspecifications',
    },
    citrus_juicers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_citrus_juicers_miscellaneous',
    },
    citrus_juicers_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_citrus_juicers_specifications',
    },
    coffee_bean_grinders_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_coffee_bean_grinders_accessories',
    },
    coffee_bean_grinders_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_coffee_bean_grinders_colourmaterialfinish',
    },
    coffee_bean_grinders_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_coffee_bean_grinders_controlpanel',
    },
    coffee_bean_grinders_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_coffee_bean_grinders_features',
    },
    coffee_bean_grinders_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_coffee_bean_grinders_technicaldata',
    },
    coffee_capsules_machines_extended: {
        defaultMessage: 'Coffee capsules machines extended',
        id: 'tech_spec_coffee_capsules_machines_extended',
    },
    coffee_drip_extended: {
        defaultMessage: 'Coffee drip extended',
        id: 'tech_spec_coffee_drip_extended',
    },
    coffee_machines_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_coffee_machines_features',
    },
    coffee_machines_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_coffee_machines_specifications',
    },
    coffee_makers_capacity: {defaultMessage: 'Capacity', id: 'tech_spec_coffee_makers_capacity'},
    coffee_makers_facets: {
        defaultMessage: 'Coffee makers facets',
        id: 'tech_spec_coffee_makers_facets',
    },
    coffee_makers_functions: {defaultMessage: 'Functions', id: 'tech_spec_coffee_makers_functions'},
    coffee_makers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_coffee_makers_generalspecifications',
    },
    coffee_makers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_coffee_makers_miscellaneous',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_accessories': {
        defaultMessage: 'Accessories',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_accessories',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_colourmaterialfinish': {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_colourmaterialfinish',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_controlpanel': {
        defaultMessage: 'Control panel',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_controlpanel',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_drip_coffee_maker': {
        defaultMessage: 'Drip coffee maker',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_drip_coffee_maker',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_espresso_maker': {
        defaultMessage: 'Espresso Maker',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_espresso_maker',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_features': {
        defaultMessage: 'Features',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_features',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_functions': {
        defaultMessage: 'Functions',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_functions',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_miscellaneous': {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_miscellaneous',
    },
    'combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_technicaldata': {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_combi_coffee_machines,_milk_frothers_and_combi_coffee_machines_technicaldata',
    },
    combi_coffee_maker_facet: {
        defaultMessage: 'Combi coffee maker facet',
        id: 'tech_spec_combi_coffee_maker_facet',
    },
    convector_heater_facet: {
        defaultMessage: 'Convector heater facet',
        id: 'tech_spec_convector_heater_facet',
    },
    convectors_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_convectors_colourmaterialfinish',
    },
    convectors_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_convectors_controlpanel',
    },
    convectors_features: {defaultMessage: 'Features', id: 'tech_spec_convectors_features'},
    convectors_functions: {defaultMessage: 'Functions', id: 'tech_spec_convectors_functions'},
    convectors_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_convectors_miscellaneous',
    },
    convectors_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_convectors_technicaldata',
    },
    cooking_food_processor_facet: {
        defaultMessage: 'Cooking food processor facet',
        id: 'tech_spec_cooking_food_processor_facet',
    },
    cooking_food_processors_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_cooking_food_processors_attachments',
    },
    cooking_food_processors_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_cooking_food_processors_capacity',
    },
    cooking_food_processors_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_cooking_food_processors_functions',
    },
    cooking_food_processors_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_cooking_food_processors_generalspecifications',
    },
    cooking_food_processors_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_cooking_food_processors_miscellaneous',
    },
    deep_fryers_and_hot_air_fryers_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_accessories',
    },
    deep_fryers_and_hot_air_fryers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_attachments',
    },
    deep_fryers_and_hot_air_fryers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_colourmaterialfinish',
    },
    deep_fryers_and_hot_air_fryers_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_controlpanel',
    },
    deep_fryers_and_hot_air_fryers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_features',
    },
    deep_fryers_and_hot_air_fryers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_functions',
    },
    deep_fryers_and_hot_air_fryers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_miscellaneous',
    },
    deep_fryers_and_hot_air_fryers_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_deep_fryers_and_hot_air_fryers_technicaldata',
    },
    deep_fryers_facet: {defaultMessage: 'Deep fryers facet', id: 'tech_spec_deep_fryers_facet'},
    dehumidifiers_certifications: {
        defaultMessage: 'Certifications',
        id: 'tech_spec_dehumidifiers_certifications',
    },
    dehumidifiers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_dehumidifiers_colourmaterialfinish',
    },
    dehumidifiers_connectivity: {
        defaultMessage: 'Connectivity',
        id: 'tech_spec_dehumidifiers_connectivity',
    },
    dehumidifiers_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_dehumidifiers_controlpanel',
    },
    dehumidifiers_extended: {
        defaultMessage: 'Dehumidifiers extended',
        id: 'tech_spec_dehumidifiers_extended',
    },
    dehumidifiers_facet: {
        defaultMessage: 'Dehumidifiers facet',
        id: 'tech_spec_dehumidifiers_facet',
    },
    dehumidifiers_features: {defaultMessage: 'Features', id: 'tech_spec_dehumidifiers_features'},
    dehumidifiers_filters: {defaultMessage: 'Filters', id: 'tech_spec_dehumidifiers_filters'},
    dehumidifiers_functions: {defaultMessage: 'Functions', id: 'tech_spec_dehumidifiers_functions'},
    dehumidifiers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_dehumidifiers_miscellaneous',
    },
    dehumidifiers_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_dehumidifiers_technicaldata',
    },
    dl_corporate_benefit_facet: {
        defaultMessage: 'DeLonghi Corporate benefit facet',
        id: 'tech_spec_dl_corporate_benefit_facet',
    },
    dolcegusto_coffee_machines_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_dolcegusto_coffee_machines_colourmaterialfinish',
    },
    dolcegusto_coffee_machines_connectivity: {
        defaultMessage: 'Connectivity',
        id: 'tech_spec_dolcegusto_coffee_machines_connectivity',
    },
    dolcegusto_coffee_machines_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_dolcegusto_coffee_machines_controlpanel',
    },
    dolcegusto_coffee_machines_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_dolcegusto_coffee_machines_features',
    },
    dolcegusto_coffee_machines_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_dolcegusto_coffee_machines_technicaldata',
    },
    drip_coffee_machines_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_drip_coffee_machines_colourmaterialfinish',
    },
    drip_coffee_machines_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_drip_coffee_machines_controlpanel',
    },
    drip_coffee_machines_features: {
        defaultMessage: 'Drip Coffee Machines Features',
        id: 'tech_spec_drip_coffee_machines_features',
    },
    drip_coffee_machines_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_drip_coffee_machines_functions',
    },
    drip_coffee_machines_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_drip_coffee_machines_technicaldata',
    },
    Drip_coffee_makers_colour_material_finish: {
        defaultMessage: 'Colour Material finish',
        id: 'tech_spec_Drip_coffee_makers_colour_material_finish',
    },
    drip_coffee_makers_controlpanel: {
        defaultMessage: 'Control Panel',
        id: 'tech_spec_drip_coffee_makers_controlpanel',
    },
    drip_coffee_makers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_drip_coffee_makers_functions',
    },
    drip_coffee_makers_technical_data: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_drip_coffee_makers_technical_data',
    },
    electric_airpots_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_electric_airpots_capacity',
    },
    electric_airpots_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_electric_airpots_functions',
    },
    electric_airpots_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_electric_airpots_generalspecifications',
    },
    electric_airpots_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_electric_airpots_miscellaneous',
    },
    electric_coffee_grinder_facet: {
        defaultMessage: 'Electric coffee grinder facet',
        id: 'tech_spec_electric_coffee_grinder_facet',
    },
    electric_knives_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_electric_knives_attachments',
    },
    electric_knives_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_electric_knives_generalspecifications',
    },
    electric_knives_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_electric_knives_miscellaneous',
    },
    electric_moka_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_electric_moka_colourmaterialfinish',
    },
    electric_moka_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_electric_moka_controlpanel',
    },
    electric_moka_features: {defaultMessage: 'Features', id: 'tech_spec_electric_moka_features'},
    electric_moka_functions: {defaultMessage: 'Functions', id: 'tech_spec_electric_moka_functions'},
    electric_moka_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_electric_moka_technicaldata',
    },
    electric_ovens_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_electric_ovens_accessories',
    },
    electric_ovens_capacity: {defaultMessage: 'Capacity', id: 'tech_spec_electric_ovens_capacity'},
    electric_ovens_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_electric_ovens_colourmaterialfinish',
    },
    electric_ovens_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_electric_ovens_controlpanel',
    },
    electric_ovens_facet: {
        defaultMessage: 'Electric ovens facet',
        id: 'tech_spec_electric_ovens_facet',
    },
    electric_ovens_features: {defaultMessage: 'Features', id: 'tech_spec_electric_ovens_features'},
    electric_ovens_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_electric_ovens_functions',
    },
    electric_ovens_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_electric_ovens_generalspecifications',
    },
    electric_ovens_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_electric_ovens_miscellaneous',
    },
    electric_ovens_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_electric_ovens_technicaldata',
    },
    espresso_makers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_espresso_makers_capacity',
    },
    espresso_makers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_espresso_makers_generalspecifications',
    },
    espresso_makers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_espresso_makers_miscellaneous',
    },
    evaporative_cooler_facet: {
        defaultMessage: 'Evaporative cooler facet',
        id: 'tech_spec_evaporative_cooler_facet',
    },
    evaporative_coolers_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_evaporative_coolers_accessories',
    },
    evaporative_coolers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_evaporative_coolers_colourmaterialfinish',
    },
    evaporative_coolers_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_evaporative_coolers_controlpanel',
    },
    evaporative_coolers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_evaporative_coolers_features',
    },
    evaporative_coolers_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_evaporative_coolers_technicaldata',
    },
    fan_heater_facet: {defaultMessage: 'Fan heater facet', id: 'tech_spec_fan_heater_facet'},
    fan_heaters_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_fan_heaters_colourmaterialfinish',
    },
    fan_heaters_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_fan_heaters_controlpanel',
    },
    fan_heaters_features: {defaultMessage: 'Features', id: 'tech_spec_fan_heaters_features'},
    fan_heaters_functions: {defaultMessage: 'Functions', id: 'tech_spec_fan_heaters_functions'},
    fan_heaters_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_fan_heaters_technicaldata',
    },
    fans_functions: {defaultMessage: 'Functions', id: 'tech_spec_fans_functions'},
    fans_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_fans_generalspecifications',
    },
    features_br_airfryers: {defaultMessage: 'Features', id: 'tech_spec_features_br_airfryers'},
    features_grill: {defaultMessage: 'Features', id: 'tech_spec_features_grill'},
    features_snackmaker: {defaultMessage: 'Features', id: 'tech_spec_features_snackmaker'},
    filter_coffee_maker_facet: {
        defaultMessage: 'Filter coffee maker facet',
        id: 'tech_spec_filter_coffee_maker_facet',
    },
    food_processors_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_food_processors_attachments',
    },
    food_processors_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_food_processors_capacity',
    },
    food_processors_extended: {
        defaultMessage: 'Food processors extended',
        id: 'tech_spec_food_processors_extended',
    },
    food_processors_facet: {
        defaultMessage: 'Food processors facet',
        id: 'tech_spec_food_processors_facet',
    },
    food_processors_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_food_processors_features',
    },
    food_processors_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_food_processors_functions',
    },
    food_processors_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_food_processors_generalspecifications',
    },
    food_processors_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_food_processors_miscellaneous',
    },
    food_processors_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_food_processors_specifications',
    },
    food_slicers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_food_slicers_generalspecifications',
    },
    food_slicers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_food_slicers_miscellaneous',
    },
    food_steamers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_food_steamers_attachments',
    },
    food_steamers_capacity: {defaultMessage: 'Capacity', id: 'tech_spec_food_steamers_capacity'},
    food_steamers_facets: {
        defaultMessage: 'Food steamers facets',
        id: 'tech_spec_food_steamers_facets',
    },
    food_steamers_features: {defaultMessage: 'Features', id: 'tech_spec_food_steamers_features'},
    food_steamers_functions: {defaultMessage: 'Functions', id: 'tech_spec_food_steamers_functions'},
    food_steamers_generalspecifications: {
        defaultMessage: 'General Specifications',
        id: 'tech_spec_food_steamers_generalspecifications',
    },
    food_steamers_highlights: {
        defaultMessage: 'Highlights',
        id: 'tech_spec_food_steamers_highlights',
    },
    food_steamers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_food_steamers_miscellaneous',
    },
    food_steamers_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_food_steamers_specifications',
    },
    fully_auto_extended: {
        defaultMessage: 'Fully auto extended',
        id: 'tech_spec_fully_auto_extended',
    },
    garement_steamer_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_garement_steamer_accessories',
    },
    garement_steamer_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_garement_steamer_features',
    },
    garement_steamer_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_garement_steamer_specifications',
    },
    gas_heater_facet: {
        defaultMessage: 'Gas heater facet',
        id: 'tech_spec_gas_heater_facet',
    },
    gas_heaters_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_gas_heaters_colourmaterialfinish',
    },
    gas_heaters_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_gas_heaters_controlpanel',
    },
    gas_heaters_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_gas_heaters_features',
    },
    gas_heaters_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_gas_heaters_miscellaneous',
    },
    gas_heaters_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_gas_heaters_technicaldata',
    },
    general_specifications_kw_airfryers: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_general_specifications_kw_airfryers',
    },
    grills_barbecues_facet: {
        defaultMessage: 'Grills and barbecues facet',
        id: 'tech_spec_grills_barbecues_facet',
    },
    grills_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_grills_capacity',
    },
    grills_extended: {
        defaultMessage: 'Grills extended',
        id: 'tech_spec_grills_extended',
    },
    grills_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_grills_functions',
    },
    grills_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_grills_generalspecifications',
    },
    grills_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_grills_miscellaneous',
    },
    grinders_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_grinders_attachments',
    },
    grinders_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_grinders_features',
    },
    grinders_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_grinders_specifications',
    },
    hand_blender_accessories_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_hand_blender_accessories_attachments',
    },
    hand_blender_accessories_categorygeneral: {
        defaultMessage: 'General',
        id: 'tech_spec_hand_blender_accessories_categorygeneral',
    },
    hand_blender_accessories_materials: {
        defaultMessage: 'Materials',
        id: 'tech_spec_hand_blender_accessories_materials',
    },
    hand_blender_accessories_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_hand_blender_accessories_miscellaneous',
    },
    hand_blenders_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_hand_blenders_attachments',
    },
    hand_blenders_facet: {
        defaultMessage: 'Hand blenders facet',
        id: 'tech_spec_hand_blenders_facet',
    },
    hand_blenders_facets: {
        defaultMessage: 'Hand blenders facets',
        id: 'tech_spec_hand_blenders_facets',
    },
    hand_blenders_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_hand_blenders_features',
    },
    hand_blenders_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_hand_blenders_functions',
    },
    hand_blenders_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_hand_blenders_generalspecifications',
    },
    hand_blenders_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_hand_blenders_specifications',
    },
    hand_mixers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_hand_mixers_attachments',
    },
    hand_mixers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_hand_mixers_capacity',
    },
    hand_mixers_facet: {
        defaultMessage: 'Hand mixers facet',
        id: 'tech_spec_hand_mixers_facet',
    },
    hand_mixers_facets: {
        defaultMessage: 'Hand mixers facets',
        id: 'tech_spec_hand_mixers_facets',
    },
    hand_mixers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_hand_mixers_features',
    },
    hand_mixers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_hand_mixers_functions',
    },
    hand_mixers_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_hand_mixers_generalspecifications',
    },
    hand_mixers_highlights: {
        defaultMessage: 'Highlights',
        id: 'tech_spec_hand_mixers_highlights',
    },
    hand_mixers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_hand_mixers_miscellaneous',
    },
    hand_mixers_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_hand_mixers_specifications',
    },
    handmixers_extended: {
        defaultMessage: 'Handmixers extended',
        id: 'tech_spec_handmixers_extended',
    },
    heating_extended: {
        defaultMessage: 'Heating extended',
        id: 'tech_spec_heating_extended',
    },
    hot_air_fryers_facet: {
        defaultMessage: 'Hot air fryers facet',
        id: 'tech_spec_hot_air_fryers_facet',
    },
    hot_water_dispenser_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_hot_water_dispenser_features',
    },
    hot_water_dispenser_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_hot_water_dispenser_specifications',
    },
    humidifiers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_humidifiers_colourmaterialfinish',
    },
    humidifiers_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_humidifiers_controlpanel',
    },
    humidifiers_facet: {
        defaultMessage: 'Humidifiers facet',
        id: 'tech_spec_humidifiers_facet',
    },
    humidifiers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_humidifiers_features',
    },
    humidifiers_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_humidifiers_technicaldata',
    },
    ice_cream_makers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_ice_cream_makers_attachments',
    },
    ice_cream_makers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_ice_cream_makers_capacity',
    },
    ice_cream_makers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_ice_cream_makers_colourmaterialfinish',
    },
    ice_cream_makers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_ice_cream_makers_features',
    },
    ice_cream_makers_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_ice_cream_makers_generalspecifications',
    },
    ice_cream_makers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_ice_cream_makers_miscellaneous',
    },
    ice_cream_makers_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_ice_cream_makers_technicaldata',
    },
    ice_cream_makers_facet: {
        defaultMessage: 'Ice-cream makers facet',
        id: 'tech_spec_ice_cream_makers_facet',
    },
    induction_hobs_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_induction_hobs_functions',
    },
    induction_hobs_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_induction_hobs_generalspecifications',
    },
    induction_hobs_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_induction_hobs_miscellaneous',
    },
    iron_extended: {
        defaultMessage: 'Iron extended',
        id: 'tech_spec_iron_extended',
    },
    ironing_station_extended: {
        defaultMessage: 'Ironing station extended',
        id: 'tech_spec_ironing_station_extended',
    },
    ironing_system_facet: {
        defaultMessage: 'Ironing system facet',
        id: 'tech_spec_ironing_system_facet',
    },
    ironing_systems_boiler: {
        defaultMessage: 'Boiler',
        id: 'tech_spec_ironing_systems_boiler',
    },
    ironing_systems_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_ironing_systems_colourmaterialfinish',
    },
    ironing_systems_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_ironing_systems_features',
    },
    ironing_systems_iron: {
        defaultMessage: 'Iron',
        id: 'tech_spec_ironing_systems_iron',
    },
    ironing_systems_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_ironing_systems_miscellaneous',
    },
    ironing_systems_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_ironing_systems_technicaldata',
    },
    irons_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_irons_capacity',
    },
    irons_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_irons_functions',
    },
    irons_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_irons_generalspecifications',
    },
    irons_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_irons_miscellaneous',
    },
    jug_blenders_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_jug_blenders_attachments',
    },
    jug_blenders_facets: {
        defaultMessage: 'Jug blenders facets',
        id: 'tech_spec_jug_blenders_facets',
    },
    jug_blenders_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_jug_blenders_features',
    },
    jug_blenders_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_jug_blenders_specifications',
    },
    juicers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_juicers_attachments',
    },
    juicers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_juicers_capacity',
    },
    juicers_design: {
        defaultMessage: 'Design',
        id: 'tech_spec_juicers_design',
    },
    juicers_extended: {
        defaultMessage: 'Juicers extended',
        id: 'tech_spec_juicers_extended',
    },
    juicers_facet: {
        defaultMessage: 'Juicers facet',
        id: 'tech_spec_juicers_facet',
    },
    juicers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_juicers_features',
    },
    juicers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_juicers_functions',
    },
    juicers_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_juicers_generalspecifications',
    },
    juicers_helpmechoose: {
        defaultMessage: 'Help me choose',
        id: 'tech_spec_juicers_helpmechoose',
    },
    juicers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_juicers_miscellaneous',
    },
    juicers_packagecontents: {
        defaultMessage: 'Package contents',
        id: 'tech_spec_juicers_packagecontents',
    },
    juicers_technicalfeatures: {
        defaultMessage: 'Technical features',
        id: 'tech_spec_juicers_technicalfeatures',
    },
    kettles_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_kettles_capacity',
    },
    kettles_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_kettles_colourmaterialfinish',
    },
    kettles_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_kettles_controlpanel',
    },
    kettles_extended: {
        defaultMessage: 'Kettles extended',
        id: 'tech_spec_kettles_extended',
    },
    kettles_facet: {
        defaultMessage: 'Kettles facet',
        id: 'tech_spec_kettles_facet',
    },
    kettles_facets: {
        defaultMessage: 'Kettles facets',
        id: 'tech_spec_kettles_facets',
    },
    kettles_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_kettles_features',
    },
    kettles_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_kettles_functions',
    },
    kettles_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_kettles_generalspecifications',
    },
    kettles_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_kettles_miscellaneous',
    },
    kettles_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_kettles_specifications',
    },
    kettles_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_kettles_technicaldata',
    },
    kima_extended: {
        defaultMessage: 'Kima extended',
        id: 'tech_spec_kima_extended',
    },
    kitchen_machine_attachments_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_kitchen_machine_attachments_attachments',
    },
    kitchen_machine_attachments_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_kitchen_machine_attachments_capacity',
    },
    kitchen_machine_attachments_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_kitchen_machine_attachments_generalspecifications',
    },
    kitchen_machine_attachments_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_kitchen_machine_attachments_miscellaneous',
    },
    kitchen_machine_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_kitchen_machine_functions',
    },
    kitchen_machines_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_kitchen_machines_attachments',
    },
    kitchen_machines_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_kitchen_machines_capacity',
    },
    kitchen_machines_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_kitchen_machines_functions',
    },
    kitchen_machines_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_kitchen_machines_generalspecifications',
    },
    kitchen_machines_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_kitchen_machines_miscellaneous',
    },
    kitchen_scales_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_kitchen_scales_capacity',
    },
    kitchen_scales_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_kitchen_scales_functions',
    },
    kitchen_scales_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_kitchen_scales_generalspecifications',
    },
    kitchen_scales_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_kitchen_scales_miscellaneous',
    },
    kw_br_choppers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_kw_br_choppers_attachments',
    },
    kw_br_choppers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_kw_br_choppers_capacity',
    },
    kw_br_choppers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_kw_br_choppers_functions',
    },
    kw_br_choppers_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_kw_br_choppers_generalspecifications',
    },
    kw_br_choppers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_kw_br_choppers_miscellaneous',
    },
    kw_airfryers_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_kw_airfryers_accessories',
    },
    kw_airfryers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_kw_airfryers_capacity',
    },
    kw_airfryers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_kw_airfryers_miscellaneous',
    },
    kw_airfryers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_kw_airfryers_functions',
    },
    kw_corporate_benefit_facet: {
        defaultMessage: 'Kenwood Corporate benefit facet',
        id: 'tech_spec_kw_corporate_benefit_facet',
    },
    manual_espresso_maker_facet: {
        defaultMessage: 'Manual espresso maker facet',
        id: 'tech_spec_manual_espresso_maker_facet',
    },
    meat_grinders_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_meat_grinders_attachments',
    },
    meat_grinders_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_meat_grinders_capacity',
    },
    meat_grinders_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_meat_grinders_functions',
    },
    meat_grinders_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_meat_grinders_generalspecifications',
    },
    meat_grinders_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_meat_grinders_miscellaneous',
    },
    meat_mincers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_meat_mincers_attachments',
    },
    meat_mincers_categorygeneral: {
        defaultMessage: 'General',
        id: 'tech_spec_meat_mincers_categorygeneral',
    },
    meat_mincers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_meat_mincers_functions',
    },
    meat_mincers_materials: {
        defaultMessage: 'Materials',
        id: 'tech_spec_meat_mincers_materials',
    },
    meat_mincers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_meat_mincers_miscellaneous',
    },
    microwave_ovens_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_microwave_ovens_capacity',
    },
    microwave_ovens_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_microwave_ovens_functions',
    },
    microwave_ovens_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_microwave_ovens_generalspecifications',
    },
    microwave_ovens_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_microwave_ovens_miscellaneous',
    },
    microwaves_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_microwaves_accessories',
    },
    microwaves_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_microwaves_colourmaterialfinish',
    },
    microwaves_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_microwaves_controlpanel',
    },
    microwaves_facet: {
        defaultMessage: 'Microwaves facet',
        id: 'tech_spec_microwaves_facet',
    },
    microwaves_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_microwaves_features',
    },
    microwaves_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_microwaves_functions',
    },
    microwaves_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_microwaves_technicaldata',
    },
    milk_frothers_facet: {
        defaultMessage: 'Milk frothers facet',
        id: 'tech_spec_milk_frothers_facet',
    },
    accessories_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_accessories_miscellaneous',
    },
    moka_coffee_maker_facet: {
        defaultMessage: 'Moka coffee maker facet',
        id: 'tech_spec_moka_coffee_maker_facet',
    },
    mugs_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_mugs_features',
    },
    mugs_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_mugs_specifications',
    },
    nescafe_dolce_gusto_coffee_machine_facet: {
        defaultMessage: 'Nescafé Dolce Gusto coffee machine facet',
        id: 'tech_spec_nescafe_dolce_gusto_coffee_machine_facet',
    },
    nespresso_coffee_machine_facet: {
        defaultMessage: 'Nespresso coffee machine facet',
        id: 'tech_spec_nespresso_coffee_machine_facet',
    },
    nespresso_coffee_machines_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_nespresso_coffee_machines_colourmaterialfinish',
    },
    nespresso_coffee_machines_connectivity: {
        defaultMessage: 'Connectivity',
        id: 'tech_spec_nespresso_coffee_machines_connectivity',
    },
    nespresso_coffee_machines_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_nespresso_coffee_machines_controlpanel',
    },
    nespresso_coffee_machines_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_nespresso_coffee_machines_features',
    },
    nespresso_coffee_machines_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_nespresso_coffee_machines_functions',
    },
    nespresso_coffee_machines_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_nespresso_coffee_machines_technicaldata',
    },
    oil_filled_radiator_facet: {
        defaultMessage: 'Oil filled radiator facet',
        id: 'tech_spec_oil_filled_radiator_facet',
    },
    oil_filled_radiators_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_oil_filled_radiators_colourmaterialfinish',
    },
    oil_filled_radiators_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_oil_filled_radiators_controlpanel',
    },
    oil_filled_radiators_facet: {
        defaultMessage: 'Oil filled radiators facet',
        id: 'tech_spec_oil_filled_radiators_facet',
    },
    oil_filled_radiators_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_oil_filled_radiators_features',
    },
    oil_filled_radiators_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_oil_filled_radiators_functions',
    },
    oil_filled_radiators_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_oil_filled_radiators_miscellaneous',
    },
    oil_filled_radiators_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_oil_filled_radiators_technicaldata',
    },
    panel_heater_facet: {
        defaultMessage: 'Panel heater facet',
        id: 'tech_spec_panel_heater_facet',
    },
    panel_radiant_heaters_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_panel_radiant_heaters_colourmaterialfinish',
    },
    panel_radiant_heaters_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_panel_radiant_heaters_controlpanel',
    },
    panel_radiant_heaters_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_panel_radiant_heaters_features',
    },
    panel_radiant_heaters_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_panel_radiant_heaters_functions',
    },
    panel_radiant_heaters_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_panel_radiant_heaters_miscellaneous',
    },
    panel_radiant_heaters_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_panel_radiant_heaters_technicaldata',
    },
    portable_air_conditioner_facet: {
        defaultMessage: 'Portable air conditioner facet',
        id: 'tech_spec_portable_air_conditioner_facet',
    },
    portable_air_conditioners_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_portable_air_conditioners_colourmaterialfinish',
    },
    portable_air_conditioners_connectivity: {
        defaultMessage: 'Connectivity',
        id: 'tech_spec_portable_air_conditioners_connectivity',
    },
    portable_air_conditioners_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_portable_air_conditioners_controlpanel',
    },
    portable_air_conditioners_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_portable_air_conditioners_features',
    },
    portable_air_conditioners_fuctions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_portable_air_conditioners_fuctions',
    },
    portable_air_conditioners_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_portable_air_conditioners_miscellaneous',
    },
    portable_air_conditioners_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_portable_air_conditioners_technicaldata',
    },
    portable_air_conditioners_Technologies: {
        defaultMessage: 'Technologies',
        id: 'tech_spec_portable_air_conditioners_Technologies',
    },
    promo_facets: {
        defaultMessage: 'Promo Facets',
        id: 'tech_spec_promo_facets',
    },
    pump_espresso_coffee_machines_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_pump_espresso_coffee_machines_accessories',
    },
    pump_espresso_coffee_machines_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_pump_espresso_coffee_machines_colourmaterialfinish',
    },
    pump_espresso_coffee_machines_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_pump_espresso_coffee_machines_controlpanel',
    },
    pump_espresso_coffee_machines_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_pump_espresso_coffee_machines_features',
    },
    pump_espresso_coffee_machines_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_pump_espresso_coffee_machines_functions',
    },
    pump_espresso_coffee_machines_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_pump_espresso_coffee_machines_technicaldata',
    },
    pump_extended: {
        defaultMessage: 'Pump extended',
        id: 'tech_spec_pump_extended',
    },
    rechargeable_stick_cleaner_facet: {
        defaultMessage: 'Rechargeable stick cleaner facet',
        id: 'tech_spec_rechargeable_stick_cleaner_facet',
    },
    rice_cookers_and_slow_cookers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_rice_cookers_and_slow_cookers_attachments',
    },
    rice_cookers_and_slow_cookers_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_rice_cookers_and_slow_cookers_capacity',
    },
    rice_cookers_and_slow_cookers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_rice_cookers_and_slow_cookers_functions',
    },
    rice_cookers_and_slow_cookers_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_rice_cookers_and_slow_cookers_generalspecifications',
    },
    rice_cookers_and_slow_cookers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_rice_cookers_and_slow_cookers_miscellaneous',
    },
    sandwich_makers_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_sandwich_makers_generalspecifications',
    },
    sandwich_makers_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_sandwich_makers_miscellaneous',
    },
    slow_cookers_and_multi_cookers_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_slow_cookers_and_multi_cookers_colourmaterialfinish',
    },
    slow_cookers_and_multi_cookers_controlpanel: {
        defaultMessage: 'Control Panel',
        id: 'tech_spec_slow_cookers_and_multi_cookers_controlpanel',
    },
    slow_cookers_and_multi_cookers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_slow_cookers_and_multi_cookers_features',
    },
    slow_cookers_and_multi_cookers_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_slow_cookers_and_multi_cookers_functions',
    },
    slow_cookers_and_multi_cookers_technical_data: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_slow_cookers_and_multi_cookers_technical_data',
    },
    special_t_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_special_t_colourmaterialfinish',
    },
    special_t_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_special_t_controlpanel',
    },
    special_t_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_special_t_features',
    },
    special_t_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_special_t_functions',
    },
    special_t_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_special_t_technicaldata',
    },
    specifications_br_airfryers: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_specifications_br_airfryers',
    },
    specifications_grill: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_specifications_grill',
    },
    specifications_snackmaker_5: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_specifications_snackmaker_5',
    },
    spin_juicers_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_spin_juicers_attachments',
    },
    spin_juicers_facets: {
        defaultMessage: 'Spin juicers facets',
        id: 'tech_spec_spin_juicers_facets',
    },
    spin_juicers_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_spin_juicers_features',
    },
    spin_juicers_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_spin_juicers_specifications',
    },
    stand_mixers_facet: {
        defaultMessage: 'Stand mixers facet',
        id: 'tech_spec_stand_mixers_facet',
    },
    steam_cleaners_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_steam_cleaners_attachments',
    },
    steam_cleaners_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_steam_cleaners_capacity',
    },
    steam_cleaners_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_steam_cleaners_generalspecifications',
    },
    steam_cleaners_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_steam_cleaners_miscellaneous',
    },
    steam_coffee_maker_facet: {
        defaultMessage: 'Steam coffee maker facet',
        id: 'tech_spec_steam_coffee_maker_facet',
    },
    steam_generator_irons_facets: {
        defaultMessage: 'Steam irons generator facets',
        id: 'tech_spec_steam_generator_irons_facets',
    },
    steam_generator_irons_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_steam_generator_irons_features',
    },
    steam_generator_irons_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_steam_generator_irons_specifications',
    },
    steam_iron_facet: {
        defaultMessage: 'Steam iron facet',
        id: 'tech_spec_steam_iron_facet',
    },
    steam_irons_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_steam_irons_accessories',
    },
    steam_irons_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_steam_irons_colourmaterialfinish',
    },
    steam_irons_facets: {
        defaultMessage: 'Steam irons facets',
        id: 'tech_spec_steam_irons_facets',
    },
    steam_irons_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_steam_irons_features',
    },
    steam_irons_features_facets: {
        defaultMessage: 'Features',
        id: 'tech_spec_steam_irons_features_facets',
    },
    steam_irons_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_steam_irons_functions',
    },
    steam_irons_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_steam_irons_miscellaneous',
    },
    steam_irons_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_steam_irons_specifications',
    },
    steam_irons_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_steam_irons_technicaldata',
    },
    stick_cleaner_facet: {
        defaultMessage: 'Stick cleaner facet',
        id: 'tech_spec_stick_cleaner_facet',
    },
    stick_cleaners_and_rechargeable_stick_cleaners_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_stick_cleaners_and_rechargeable_stick_cleaners_accessories',
    },
    stick_cleaners_and_rechargeable_stick_cleaners_colourmaterialfinish: {
        defaultMessage: 'Colour Material Finish',
        id: 'tech_spec_stick_cleaners_and_rechargeable_stick_cleaners_colourmaterialfinish',
    },
    stick_cleaners_and_rechargeable_stick_cleaners_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_stick_cleaners_and_rechargeable_stick_cleaners_features',
    },
    stick_cleaners_and_rechargeable_stick_cleaners_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_stick_cleaners_and_rechargeable_stick_cleaners_technicaldata',
    },
    toasters_accessories: {
        defaultMessage: 'Accessories',
        id: 'tech_spec_toasters_accessories',
    },
    toasters_attachments: {
        defaultMessage: 'Attachments',
        id: 'tech_spec_toasters_attachments',
    },
    toasters_controlpanel: {
        defaultMessage: 'Control panel',
        id: 'tech_spec_toasters_controlpanel',
    },
    toasters_extended: {
        defaultMessage: 'Toasters extended',
        id: 'tech_spec_toasters_extended',
    },
    toasters_facet: {
        defaultMessage: 'Toasters facet',
        id: 'tech_spec_toasters_facet',
    },
    toasters_facets: {
        defaultMessage: 'Toasters facets',
        id: 'tech_spec_toasters_facets',
    },
    toasters_features: {
        defaultMessage: 'Features',
        id: 'tech_spec_toasters_features',
    },
    toasters_functions: {
        defaultMessage: 'Functions',
        id: 'tech_spec_toasters_functions',
    },
    toasters_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_toasters_generalspecifications',
    },
    toasters_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_toasters_miscellaneous',
    },
    toasters_specifications: {
        defaultMessage: 'Specifications',
        id: 'tech_spec_toasters_specifications',
    },
    toasters_technicaldata: {
        defaultMessage: 'Technical Data',
        id: 'tech_spec_toasters_technicaldata',
    },
    vacuum_cleaners_capacity: {
        defaultMessage: 'Capacity',
        id: 'tech_spec_vacuum_cleaners_capacity',
    },
    vacuum_cleaners_generalspecifications: {
        defaultMessage: 'General specifications',
        id: 'tech_spec_vacuum_cleaners_generalspecifications',
    },
    vacuum_cleaners_miscellaneous: {
        defaultMessage: 'Miscellaneous',
        id: 'tech_spec_vacuum_cleaners_miscellaneous',
    },
    W927: {
        defaultMessage: 'W927',
        id: 'tech_spec_W927',
    },
    what_to_prepare_food_processors: {
        defaultMessage: 'What would you like to prepare with your food processor?',
        id: 'tech_spec_what_to_prepare_food_processors',
    },
    what_to_prepare_hand_blender: {
        defaultMessage: 'What would you like to prepare with your hand blender?',
        id: 'tech_spec_what_to_prepare_hand_blender',
    },
    what_to_prepare_hand_mixers: {
        defaultMessage: 'What else do you like to prepare?',
        id: 'tech_spec_what_to_prepare_hand_mixers',
    },
    what_to_prepare_jug_blenders: {
        defaultMessage: 'What else do you like to prepare?',
        id: 'tech_spec_what_to_prepare_jug_blenders',
    },
})
